import { fetcher } from "helpers/fetcher";

import { TUpdateAddressReq, TUpdateAddressRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateAddress = async (payload: TUpdateAddressReq) => {
  return await fetcher<TUpdateAddressRes, TUpdateAddressReq["data"]>(
    ENDPOINT.USER.UPDATE_ADDRESS,
    {
      data: payload.data,
      headers: {
        [API_HEADER.USER_ID]: payload.idUser,
        [API_HEADER.VERSION]: ENDPOINT.USER.UPDATE_ADDRESS.version,
      },
    }
  );
};

export const mutationUpdateAddress = async (payload: TUpdateAddressReq) => {
  return (await updateAddress(payload)).data.message;
};

mutationUpdateAddress._key = (payload: TUpdateAddressReq) => [
  ENDPOINT.USER.UPDATE_ADDRESS.url,
  payload,
];
